import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import Chip from './Chip';

const propTypes = {
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
};
const defaultProps = {
  disabled: false,
  value: undefined,
  onChange: undefined,
};

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '12px',
  },
}));

function ChipList({ disabled, options, value, onChange }) {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      {options.map(chip => (
        <Chip
          key={chip.value}
          disabled={disabled}
          checked={value === chip.value}
          label={chip.label}
          value={chip.value}
          onClick={() => onChange?.(chip.value)}
          onDelete={() => onChange?.('')}
        />
      ))}
    </Box>
  );
}

ChipList.propTypes = propTypes;
ChipList.defaultProps = defaultProps;

export default ChipList;
